import { apiFetch } from './apiFetch';

export async function createUser(formulary) {
  const payload = {
    nombre: formulary.nombre,
    apellidos: formulary.apellidos,
    email: formulary.email,
    telefono: formulary.telefono,
    codigoPostal: formulary.codigoPostal,
  };

  await apiFetch(process.env.REACT_APP_CREATE_USER, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  return true;
}
